module.exports = __webpack_public_path__ + "selwebee_spt_playground-ENGLISH-1b8051f33b5ae26c2885757bdc80577e.png";